import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden" }


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFacetUnknown',
  setup(__props) {

console.warn('Unknown facet id');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})